import { useQueryClient } from "react-query";
import { useMutation } from "react-query";
import { notification } from "antd";
import { isError } from "utils/api/models/api-response";
import { AddCategoryAsync } from "services/categories";
import { t } from "i18next";

export default function AddCategory() {
  const queryClient = useQueryClient();
  return {
    ...useMutation(AddCategoryAsync, {
      onSuccess: async (res) => {
        if (!isError(res)) {
          notification.open({
            message: t("category_added_successfully"),
          });
          queryClient.invalidateQueries("categories-selector");
        }
      },
    }),
  };
}
